import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './form-item-business-financial-planning-cmb.component.scss';
var FormItemBusinessFinancialPlanningCmb = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemBusinessFinancialPlanningCmb, _super);
    function FormItemBusinessFinancialPlanningCmb(element) {
        return _super.call(this, element) || this;
    }
    FormItemBusinessFinancialPlanningCmb.prototype.init = function () {
        this.form = this.element.querySelector('form');
        this.submitBtn = Array.from(this.element.querySelectorAll(".js-business-financial-planning__button"));
        this.formModal = this.element.closest('.modal.js-apply-now-modal');
        this.showMoreBtn = this.element.querySelector('.data-privacy-collapse-show');
        this.showLessBtn = this.element.querySelector('.data-privacy-collapse-hide');
        this.dataPrivacyDetailArea = this.element.querySelector('.data-privacy-detail');
        this.dataSharingGroupHideBtn = this.element.querySelector('.data-sharing-group-hide-btn');
        this.dataSharingGroupShowBtn = this.element.querySelector('.data-sharing-group-show-btn');
        this.dataSharingGroupTextArea = this.element.querySelector('.data-sharing-group');
        this.dataSharing3rdPartyShowBtn = this.element.querySelector('.data-sharing-3rd-party-show-btn');
        this.dataSharing3rdPartyHideBtn = this.element.querySelector('.data-sharing-3rd-party-hide-btn');
        this.dataSharing3rdPartyTextArea = this.element.querySelector('.data-sharing-3rd-party');
        this.dataSharingBoardersHideBtn = this.element.querySelector('.data-sharing-boarders-hide-btn');
        this.dataSharingBoardersShowBtn = this.element.querySelector('.data-sharing-boarders-show-btn');
        this.dataSharingBoardersTextArea = this.element.querySelector('.data-sharing-boarders');
    };
    FormItemBusinessFinancialPlanningCmb.prototype.bindEvents = function () {
        var _this = this;
        this.submitBtn.map(function (item) { return item.addEventListener("click", function (event) {
            var _button = event.target;
            var _form = _button.closest("form");
            var formFields = _form.querySelectorAll("input, select");
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll(".form__group--error"));
            if (valid.length === 0) {
                _this.submitForm(_form);
            }
        }); });
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll('input, select, textarea'));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener('blur', function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        this.showLessBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.showLessBtn.setAttribute('hidden', 'true');
            _this.showMoreBtn.removeAttribute('hidden');
            _this.dataPrivacyDetailArea.setAttribute('hidden', 'true');
        });
        this.showMoreBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.showMoreBtn.setAttribute('hidden', 'true');
            _this.showLessBtn.removeAttribute('hidden');
            _this.dataPrivacyDetailArea.removeAttribute('hidden');
        });
        this.dataSharingGroupHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.setAttribute('hidden', 'true');
            _this.dataSharingGroupHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingGroupShowBtn.removeAttribute('hidden');
        });
        this.dataSharingGroupShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.removeAttribute('hidden');
            _this.dataSharingGroupHideBtn.removeAttribute('hidden');
            _this.dataSharingGroupShowBtn.setAttribute('hidden', 'true');
        });
        this.dataSharing3rdPartyHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.setAttribute('hidden', 'true');
            _this.dataSharing3rdPartyShowBtn.removeAttribute('hidden');
            _this.dataSharing3rdPartyHideBtn.setAttribute('hidden', 'true');
        });
        this.dataSharing3rdPartyShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.removeAttribute('hidden');
            _this.dataSharing3rdPartyHideBtn.removeAttribute('hidden');
            _this.dataSharing3rdPartyShowBtn.setAttribute('hidden', 'true');
        });
        this.dataSharingBoardersShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.removeAttribute('hidden');
            _this.dataSharingBoardersShowBtn.setAttribute('hidden', 'true');
            _this.dataSharingBoardersHideBtn.removeAttribute('hidden');
        });
        this.dataSharingBoardersHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.setAttribute('hidden', 'true');
            _this.dataSharingBoardersHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingBoardersShowBtn.removeAttribute('hidden');
        });
        // Reset the form
        this.form.addEventListener("custom_form_reset_event", function (pEvent) {
            _this.resetForm();
        }, false);
    };
    FormItemBusinessFinancialPlanningCmb.prototype.submitForm = function (form) {
        var _this = this;
        // success screens
        var loader = form.querySelector(".form__loader--container");
        var thankYou = form.querySelector(".form__thankyou--container");
        // const declined = form.querySelector(`.form__declined--container`);
        var fieldsContainer = form.querySelector(".form-container__fields");
        var _email = form.querySelector("input[name=email]");
        var _recipient = form.querySelector("input[name=recipient]");
        var _subject = form.querySelector("input[name=subject]");
        var _redirect = form.querySelector("input[name=redirect]");
        var _firstname = this.form.querySelector("input[name=first-name]");
        var _lastName = this.form.querySelector("input[name=last-name]");
        var _cellNumber = this.form.querySelector("input[name=cell-number]");
        var _emailAddress = this.form.querySelector("input[name=email-address]");
        var _product = this.form.querySelector("input[name=product]");
        var _businessName = this.form.querySelector("input[name=business-name]");
        var _date = this.form.querySelector("input[name=date]");
        var _time = this.form.querySelector("select[name=time]");
        var dataPrivacyConsent = this.form.querySelector("input[name=popia-consent]");
        var _dateTime = "anytime";
        if (_date && _time) {
            if (_time.value !== "Anytime") {
                _dateTime = _date.value + " " + _time.value;
            }
        }
        var _postData = {
            'recipient': (_recipient ? _recipient.value : ""),
            'email': (_email ? _email.value : ""),
            'subject': (_subject ? _subject.value : ""),
            'redirect': (_redirect ? _redirect.value : ""),
            'firstName': (_firstname ? _firstname.value : ""),
            'lastName': (_lastName ? _lastName.value : ""),
            'contactNo': (_cellNumber ? _cellNumber.value : ""),
            'emailAddress': (_emailAddress ? _emailAddress.value : ""),
            'product': (_product ? _product.value : ""),
            'bestTimeToCallDate': (_date.value ? _date.value : ""),
            'bestTimeToCallTime': (_time.value ? _time.value : ""),
            'dataPrivacyConsent': ((dataPrivacyConsent ? (dataPrivacyConsent.checked ? "YES" : "NO") : "NO")),
            'dataSharingGroup': this.getDataConsentValue(form, 'data-sharing-group'),
            'dataSharing3rdParty': this.getDataConsentValue(form, 'data-sharing-3rd-party'),
            'dataSharingBoarders': this.getDataConsentValue(form, 'data-sharing-boarders'),
        };
        // loader + hide form
        loader.classList.add("active");
        fieldsContainer.classList.add("hidden");
        // variables
        var url = this.baseUrl + "/bcleadUtils/financial-planning-lead";
        var _config = {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, _postData, _config).then(function (pResponse) {
            // service ok
            loader.classList.remove("active");
            _this.analyticsService.dtmFormComplete("complete", "");
            thankYou.classList.remove("hidden");
            thankYou.classList.add("active");
        }).catch(function (pResponse) {
            // service failed
            loader.classList.remove("active");
            this.analyticsService.dtmFormComplete("complete", "");
            thankYou.classList.remove("hidden");
            thankYou.classList.add("active");
        });
    };
    FormItemBusinessFinancialPlanningCmb.prototype.resetForm = function () {
        if (this.form) {
            this.form.reset();
            var formContainerLoader = this.element.querySelector(".form__loader--container");
            var formContainerFields = this.element.querySelector(".form-container__fields");
            var formContainerThankyou = this.element.querySelector(".form__thankyou--container");
            formContainerLoader.classList.remove("active");
            formContainerThankyou.classList.remove("active");
            formContainerThankyou.classList.add("hidden");
            formContainerFields.classList.remove("hidden");
        }
    };
    FormItemBusinessFinancialPlanningCmb.prototype.getDataConsentValue = function (form, selector) {
        var radioBtn = form.querySelector("input[name=\"" + selector + "\"]:checked");
        if (radioBtn && radioBtn.checked) {
            return radioBtn.value.toUpperCase();
        }
        else {
            return null;
        }
    };
    return FormItemBusinessFinancialPlanningCmb;
}(Base));
export { FormItemBusinessFinancialPlanningCmb };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-business-financial-planning-cmb/form-item-business-financial-planning-cmb.component.ts
// module id = 1037
// module chunks = 0